import * as React from 'react';
import autobind from 'autobind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { connect } from "react-redux";
import { Dispatch } from 'redux';
import { actionAvailabilitiesCreators } from "src/store/allotments/availabilities-actions";
import { AllotmentDataService } from "src/app/products/allotment/form/allotment-form.data";
import { actionCreators } from "src/store/products/product-form-nav-actions";

import { ContractDataService } from '../../../contract/form/contract-form.data';
import { AllotmentAvailabilityController } from 'src/app/products/allotment/form/parts/allotment-availability.controller';
interface PropsFromState {
	availabilities: AvailabilityAllotments | null;
	otherLoadedEntities: ReadonlyArray<Readonly<{
		entity: ProductFormItemType
	}>>;
}

interface PropsFromDispatch {
	loadAvailabilities: (supplierId: number, allotment: AllotmentItem) => any;
	allotmentLoaded: (contractItem: ContractItem, allotment: AllotmentItem) => any;
	contractsLoaded: (product: ProductItem | TourItineraryItem, contracts: ContractItem[]) => any;

}
interface ProductAvailabilitiesControllerProps extends ComponentViewProps<ProductItem> {
	contextService: any;
	defaultLanguage: string;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
}

@observer
class ProductAvailabilitiesController extends React.Component<ProductAvailabilitiesControllerProps & PropsFromDispatch & PropsFromState, any> {
	@observable
	protected supplier: any[] = [];
	availabilities: AvailabilityAllotments = {};
	protected contractDataService: ContractDataService;
	protected allotmentDataService: AllotmentDataService;

	constructor(props) {
		super(props);
	}

	@autobind
	fillAvailabilitiesBycontracs(allotment: AllotmentItem, supplierId: number, supplierTitle: string) {
		const allotmentInStore: AllotmentItem = this.props.otherLoadedEntities.find(e => e != null && e.entity == allotment.entity) as any;
		this.props.loadAvailabilities(supplierId, allotmentInStore);
		if (this.supplier.find(x => x.value == supplierId) == null)
			this.supplier.push({ value: supplierId, label: supplierTitle });
	}

	componentDidMount() {
		this.allotmentDataService = AllotmentDataService.make();
		this.allotmentDataService.addFilter('isDeleted', 'eq', false);
		this.allotmentDataService.addSorting('id', 'asc', true);
		this.allotmentDataService.pageSize = 1;
		const productInStore: ProductItem = this.props.otherLoadedEntities.find(e => e != null && e.entity == this.props.model.entity) as any;
		if (productInStore.contracts != null && productInStore.contracts.length > 0) {
			for (const c of productInStore.contracts) {
				const contract: ContractItem = this.props.otherLoadedEntities.find(e => e != null && e.entity == c.entity) as any;
				if (contract.allotment != null) {
					this.fillAvailabilitiesBycontracs(contract.allotment, contract.entity.supplierId, contract.entity.supplierTitle);
				}
				else if (contract.entity.allotmentId > 0 && !this.IsThereAreAllSupplier() ) {// esto es porque pueden haber allotment que no se hayan guardado en el store porque no se ha ido al contrato que lo tiene
					this.allotmentDataService.addFilter('id', 'eq', contract.entity.allotmentId);
					if (this.allotmentDataService.items.find(a => a.id == contract.entity.allotmentId) == null)
						this.allotmentDataService.load(query => query).then(allotments => {
							let allotment = allotments.length > 0 ? allotments[0] : null;
							if (allotment != null) {
								this.props.allotmentLoaded(contract.entity, allotment);
								this.fillAvailabilitiesBycontracs(allotment, contract.entity.supplierId, contract.entity.supplierTitle);

							}
						})
					
				}
			}
		}
		else {

			this.contractDataService = ContractDataService.make();
			this.contractDataService.addFilter('isDeleted', 'eq', false);
			this.contractDataService.addFilter('productId', 'eq', this.props.model.id);
			this.contractDataService.addSorting('id', 'asc', true);
			this.contractDataService.pageSize = 25;
			this.contractDataService.load(query => query)
				.then((items) => {
					this.props.contractsLoaded(this.props.model, items.slice());
					for (let contract of items) {
						if (contract.allotmentId > 0) {
							let allotmentInStore = {
								id: contract.allotmentId,
								name: '',
								parentAllotmentId: null,
								allotmentRanges: null,
								contracts: [contract],
								productId: this.props.model.id,
								supplierId: contract.supplierId,
								byDefault: true,
								productType: this.props.model.productType,
								categoryId: this.props.model.categoryId,
								product: this.props.model,
								entity: null,
								isDeleted: false,
								validate: null,
								validateDynamicProperty: null
							};
							this.props.loadAvailabilities(contract.supplierId, allotmentInStore);
							if (this.supplier.find(x => x.value == contract.supplierId) == null)
								this.supplier.push({ value: contract.supplierId, label: contract.supplierTitle });
						}

					}
				})
				.catch((error) => {
					this.props.setBusy(false);
				});


		}
	}
	componentWillReceiveProps(nextProps: Readonly<ProductAvailabilitiesControllerProps>, nextContext: any) {

	}
	IsThereAreAllSupplier() {
		const productInStore: ProductItem = this.props.otherLoadedEntities.find(e => e != null && e.entity == this.props.model.entity) as any;

		if ((productInStore.contracts && productInStore.contracts.length > 0)) {
			let supp = productInStore.contracts.filter(c => c.entity.allotmentId > 0).map(c => c.supplierId);
			let result = supp.every(s => this.supplier.some(sup => sup.value == s));
			return result;
		}
		return false;
	}
	render() {
		if (this.supplier.length == 0 || !this.IsThereAreAllSupplier()) {
			return null;
		}
		let supp = this.supplier[0];
		let allotment = this.props.availabilities[supp.value.toString()]
		return (
			<AllotmentAvailabilityController
				defaultLanguaje={this.props.defaultLanguage}
				suppliers={this.supplier}
				idSuplier={supp.value}
				contextService={this.props.contextService}
				mode={"edit"}
				onModeChanged={this.props.onModeChanged}
				model={allotment.id}
				setBusy={this.props.setBusy}
			/>
		);
	}
}
const mapStateToProps = (state: IApplicationState, props: ComponentViewProps<ProductItem>): PropsFromState => ({
	availabilities: state.availabilities,
	otherLoadedEntities: state.otherLoadedEntities,
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
	loadAvailabilities: (supplierId: number, allotment: AllotmentItem) =>
		dispatch(actionAvailabilitiesCreators.loadAvailabilities(supplierId, allotment)),
	allotmentLoaded: (
		contract: ContractItem,
		allotment: AllotmentItem,
	) => dispatch(actionCreators.productFormRelationshipLoaded(contract, allotment, "allotment")),
	contractsLoaded: (
		product: ProductItem | TourItineraryItem,
		contracts: ContractItem[],
	) => dispatch(actionCreators.productFormRelationshipLoaded(product, contracts, "contracts")),
});

const connected = connect(mapStateToProps, mapDispatchToProps)(ProductAvailabilitiesController);
export { connected as ProductAvailabilitiesController };



// WEBPACK FOOTER //
// ./src/app/products/products/form/parts/product-availabilities.controller.tsx